import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactActionsService } from '@shared/modules/contacts/data-access/contact-actions/contact-actions.service';

@NgModule({
  imports: [CommonModule]
})
export class ContactActionsModule {
  static forRoot(): ModuleWithProviders<ContactActionsModule> {
    return {
      ngModule: ContactActionsModule,
      providers: [ContactActionsService]
    };
  }
}
